import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { Check, MessageSquare, ListChecks, Zap } from "lucide-react";

export const WORKSPACE_STEPS = [
  { key: "clarify", i18nKey: "workspace.stepClarify", icon: MessageSquare },
  { key: "prioritize", i18nKey: "workspace.stepPrioritize", icon: ListChecks },
  { key: "recommended", i18nKey: "workspace.stepDecide", icon: Zap },
];

export function WorkspaceRail({ d, onBack, stepIndex }) {
  const { t } = useTranslation();
  return (
    <aside className="border-b border-border bg-secondary/30 p-6 lg:min-h-[calc(100vh-4rem)] lg:border-b-0 lg:border-r lg:p-8">
      <button
        onClick={onBack}
        className="mb-6 text-xs font-medium text-muted-foreground hover:text-foreground"
      >
        {t("workspace.allDecisions")}
      </button>
      <div className="mb-2 flex items-center gap-2">
        <Badge variant="outline" className="capitalize">
          {d.domain}
        </Badge>
        <Badge
          className={
            d.stakes === "high"
              ? "bg-danger text-white"
              : d.stakes === "low"
              ? "bg-success text-white"
              : "bg-warning text-white"
          }
        >
          {t("workspace.stakes", { level: t(`workspace.stakesLevel.${d.stakes}`, d.stakes) })}
        </Badge>
      </div>
      <h1 className="font-display text-xl font-extrabold leading-tight tracking-tight">
        {d.title}
      </h1>
      {d.decision_summary && (
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          {d.decision_summary}
        </p>
      )}

      <div className="mt-8 space-y-1">
        {WORKSPACE_STEPS.map((s, i) => {
          const done = i < stepIndex;
          const active = i === stepIndex;
          return (
            <div
              key={s.key}
              className={`flex items-center gap-3 rounded-md px-3 py-2 text-sm ${
                active ? "bg-card font-semibold shadow-sm" : "text-muted-foreground"
              }`}
            >
              <div
                className={`flex h-6 w-6 items-center justify-center rounded-full text-xs ${
                  done
                    ? "bg-success text-white"
                    : active
                    ? "bg-primary text-primary-foreground"
                    : "bg-secondary text-muted-foreground"
                }`}
              >
                {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
              </div>
              {t(s.i18nKey)}
            </div>
          );
        })}
      </div>

      {d.assumptions?.length > 0 && (
        <div className="mt-8">
          <p className="mb-2 text-xs font-semibold uppercase tracking-overline text-muted-foreground">
            {t("workspace.assumptions")}
          </p>
          <ul className="space-y-1.5">
            {d.assumptions.map((a) => (
              <li key={a} className="text-xs text-muted-foreground">
                · {a}
              </li>
            ))}
          </ul>
        </div>
      )}
    </aside>
  );
}
